<template>
<div class="contentBox payPage">
    <div class="pageTitle">
        <h1>支付</h1>
    </div>
    <table class="orderInfo">
        <tbody>
            <tr>
                <td class="firstTd">订单号</td>
                <td class="last">{{order.paySerial}}</td>
            </tr>
            <tr>
                <td class="firstTd">订单描述</td>
                <td class="last">{{order.packageTitle}}x{{order.count}}</td>
            </tr>
            <tr>
                <td class="firstTd">金额</td>
                <td class="last blue">¥{{order.totalPrice}}</td>
            </tr>
            <tr>
                <td class="firstTd">支付方式</td>
                <td class="last">
                    <el-radio-group v-model="payType" @change="switchPayType">
                        <el-radio label="wechat"><img src="../../../assets/weixinpay.svg" alt="" />微信</el-radio>
                        <el-radio label="ali"><img src="../../../assets/alipay.svg" alt="" />支付宝</el-radio>
                    </el-radio-group>
                </td>
            </tr>
            <tr>
                <td class="firstTd"></td>
                <td class="last">
                    <div class="qrcodetd">
                        <img :src="qrCodeData" v-if="qrCodeReady" alt="" />
                        <p class="payTips" v-if="payType === 'wechat'">请使用微信扫码完成支付</p>
                        <p class="payTips" v-if="payType === 'ali'"></p>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
</template>

<script>
    import common from '../../../common.vue';
    const PAY_TYPE_ALI = 1;
    const PAY_TYPE_WECHAT = 2;

    export default {
        name: "Pay",
        data() {
            return {
                order: {},
                payType: "wechat",
                qrCodeReady: false,
                qrCodeData: null,
                payMeter: -1
            };
        },
        methods: {
            /**
             * 获取订单
             * @param oid
             */
            getOrder(oid){
                let _this = this;
                _this.$axios.post(common._BASE_ + '/order/loadOrder',
                    _this.$qs.stringify({oId: oid})).then(function (res) {
                    let r = res.data;
                    if (r.code === 0 && r.data) {
                        _this.order = r.data;
                        _this.getPayCode();
                    }
                    parseInt(r.code) < 0 && _this.jumpPage('/login');
                });
            },
            /**
             * 根据支付方式获取二维码
             */
             getPayCode(){
                let _this = this;
                _this.$axios.post(common._BASE_ + '/order/nativePay',
                    _this.$qs.stringify({oId: _this.orderId, type: (_this.payType === 'wechat'? PAY_TYPE_WECHAT: PAY_TYPE_ALI)})).then(function (res) {
                    let r = res.data;
                    if (r.code === 0 && r.data) {
                        if(_this.payType === 'wechat'){
                            _this.qrCodeData = "data:image/jpeg;base64," + r.data;
                            _this.qrCodeReady = true;
                            setTimeout(function(){
                                _this.queryPayStatus()
                            }, 5000);
                        }else{
                            // 转至支付宝支付
                            document.querySelector('body').innerHTML = r.data;
                            document.forms[0].submit();
                        }
                    }else{
                        _this.$notify({
                            title: '错误',
                            message: '获取支付信息失败',
                            type: 'error',
                            duration: 1000
                        });
                    }
                    parseInt(r.code) < 0 && _this.jumpPage('/login');
                });
            },

            /**
             * 查询支付状态
             */
            queryPayStatus: function(){
                let _this = this;
                _this.$axios.post(common._BASE_ + '/order/queryOrder',
                    _this.$qs.stringify({oId: _this.orderId, type: (_this.payType === 'wechat'? PAY_TYPE_WECHAT: PAY_TYPE_ALI)})).then(function (res) {
                    let r = res.data;
                    if(r.code === 200){
                        _this.$notify({
                            title: '成功',
                            message: '支付成功',
                            type: 'success',
                            duration: 1000,
                            onClose: () => {
                                _this.jumpPage('/finance/my-order');
                            }
                        });
                    }else if([300, 0].includes(r.code)){
                        // 如果是待付状态，3秒后重试
                        _this.payMeter = setTimeout(function(){
                            _this.queryPayStatus()
                        }, 1000);
                    }else{
                        // 查询意外
                        _this.$notify({
                            title: '意外',
                            message: '查询支付状态异常，将跳至订单页面',
                            type: 'warning',
                            duration: 1000,
                            onClose: () => {
                                _this.jumpPage('/finance/my-order');
                            }
                        });
                    }
                });
            },

            /**
             * 切换了支付方式，重新申请二维码
             */
            switchPayType(){
                this.getPayCode();
            }
        },
        mounted(){
            // 订单Id
            let oid = this.$route.params.oid || this.$route.query.oid;
            if(oid && parseInt(oid) > 0){
                this.orderId = oid;
                this.getOrder(oid);
            }else{
                this.$router.push({
                    path: '/finance/my-order'
                });
            }
        },
        beforeDestroy(){
            clearTimeout(this.payMeter);
        }

    };
</script> 

<style lang="less">
.payPage {
    .rechargePage {
        width: 824px;
    }

    .blue {
        color: #306FF6;
    }

    .orderInfo {
        width: 100%;
        border: solid 1px #e8e8e8;
        border-collapse: collapse;
        font-size: 14px;
        background: #ffffff;

        tr,
        td {
            height: 58px;
            border: 1px solid #e8e8e8;
        }

        .qrcodetd {
            padding: 19px 0;
            width: 193px;
            display: flex;
            flex-direction: column;
            align-items: center;

            img {
                width: 193px;
            }

            .payTips {
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
                color: #59c24b;
                margin-top: 6px;
            }
        }

        .firstTd {
            width: 110px;
            text-align: center;
        }

        .last {
            padding-left: 22px;
        }

        .el-radio-group {
            display: flex;
            align-items: center;

            .el-radio {
                display: flex;
                align-items: center;
            }

            .el-radio__inner {
                width: 20px;
                height: 20px;
            }

            .el-radio__input.is-checked .el-radio__inner {
                border: none;
                background: url("../../../assets/checked.svg");
            }

            .el-radio__inner::after {
                display: none;
            }

            .el-radio__label {
                display: flex;
                align-items: center;

                img {
                    margin-right: 8px;
                }
            }

            .el-radio__input.is-checked+.el-radio__label {
                color: #221816;
            }
        }
    }
}
</style>